import {
    AnimationBaseController,
    GameApiBase,
    IAnimationControllerConfiguration,
    Inject,
    Key,
    SoundType,
} from '@denishussar/html5-game-engine';
import { Sounds } from '../Constants/Sounds';
import { SoundModel } from '../Models/SoundModel';

export interface IButtonControllerOptions {
    onClick: () => void;
    hotKey?: string;
    notAnimated: boolean | null;
}

export class ButtonController extends AnimationBaseController {
    $model: any;

    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;

    public selected = false;

    public constructor(@Inject private _options: IButtonControllerOptions,
                       @Inject private _arenaApi: GameApiBase,
                       @Inject private soundLevels: SoundModel,
                       ) {
        super('ButtonController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        let keyboard = null;

        if (this._options.hotKey) {
            keyboard = {
                [Key[this._options.hotKey]]: {
                    pressed: () => {
                        if (!this._enabled) {
                            return;
                        }
                        this._pressed = true;
                        if(!this._options.notAnimated)
                        this.gotoAndStop('press');
                    },
                    released: () => {
                        if (!this._enabled || !this._pressed) {
                            return;
                        }
                        this._pressed = false;
                        if(!this._options.notAnimated)
                        this.gotoAndStop('active');

                        if (this._options.onClick) {
                            this._options.onClick();
                        }
                    },
                    press: () => {
                    },
                },
            };
        }

        return <IAnimationControllerConfiguration>{
            childControllers: {},
            sounds: [
                {
                    id: Sounds.BUTTON,
                    type: SoundType.SFX,
                },
            ],
            onPointerDown: () => {
                if (!this._enabled) {
                    return;
                }
                this.soundManager.play(Sounds.BUTTON, false, SoundModel.UI );
                this._pointerDown = true;
                if(!this._options.notAnimated)
                this.gotoAndStop('press');
            },
            onPointerOut: () => {
                if (!this._enabled) {
                    return;
                }
                if (!this._pointerDown) {
                    if(!this._options.notAnimated)
                    this.gotoAndStop(this.selected ? 'press' : 'active');
                }
                this._pointerOver = false;
            },
            onPointerOver: () => {
                if (!this._enabled) {
                    return;
                }
                if (this._pointerDown) {
                    if(!this._options.notAnimated)
                    this.gotoAndStop('press');
                } else {
                    if(!this._options.notAnimated)
                    this.gotoAndStop(this.selected ? 'press' : 'hover');
                }
                this._pointerOver = true;
            },
            onPointerUp: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = false;
                if(!this._options.notAnimated)
                this.gotoAndStop(this.selected ? 'press' : 'active');
            },
            onPointerUpOutside: () => {
                if (!this._enabled) {
                    return;
                }
                if(!this._options.notAnimated)
                this.gotoAndStop(this.selected ? 'press' : 'active');
                this._pointerDown = false;
            },
            onTap: () => {
                if (!this._enabled) {
                    return;
                }
                if (this._options.onClick) {
                    this._options.onClick();
                }
            },
            keyboard: keyboard,
        };
    }

    public toggle(select: boolean) {
        this.selected = select;
        if(!this._options.notAnimated)
        this.gotoAndStop(this.selected ? 'press' : 'active');
    }

    public disabled() {
        this._enabled = false;
        this._pressed = false;
        this._pointerDown = false;
        
    }

    public enabled() {
        this._enabled = true;
        if(!this._options.notAnimated)
        this.gotoAndStop('active');
    }

    protected onInitialize(): void {
    }
}
